import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { AppSvgIconComponent } from '@vallift/ngl';
import {
  TEXT_ALIGNMENT_OPTIONS,
  TEXT_FONT_STYLE_OPTIONS,
  TEXT_FONT_WEIGHT_OPTIONS,
  type TextAlignment,
  type TextFontStyle,
  type TextFontWeight,
} from '../typography-config.constants';

@Component({
  selector: 'app-typography-config-controls',
  standalone: true,
  imports: [AppSvgIconComponent],
  templateUrl: './typography-config-controls.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TypographyConfigControlsComponent {
  readonly alignment = input.required<TextAlignment>();
  readonly fontStyle = input.required<TextFontStyle>();
  readonly fontWeight = input.required<TextFontWeight>();

  readonly alignmentChange = output<TextAlignment>();
  readonly fontStyleChange = output<TextFontStyle>();
  readonly fontWeightChange = output<TextFontWeight>();

  readonly alignmentOptions = TEXT_ALIGNMENT_OPTIONS;
  readonly fontStyleOptions = TEXT_FONT_STYLE_OPTIONS;
  readonly fontWeightOptions = TEXT_FONT_WEIGHT_OPTIONS;
}
